import {Outlet,useNavigate} from "react-router-dom";
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import StarIcon from '@mui/icons-material/Star';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled, alpha,useTheme } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import AddIcon from '@mui/icons-material/Add';
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert'
import CodeIcon from '@mui/icons-material/Code'
import RefreshIcon from '@mui/icons-material/Refresh'
import AlarmIcon from '@mui/icons-material/Alarm'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {CircularProgress, Container, Link, Switch} from '@mui/material'
import {useSelector, useDispatch} from 'react-redux';
import { login,logout } from "../Redux/authSlice";
import {toggleTheme} from "../Redux/themeSlice";
import {add_tests} from "../Redux/testsSlice";
import {add_test} from "../Redux/testSlice";
import Item from './Item'
import HomeIcon from "@mui/icons-material/Home";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import PremiumDialog from "./PremiumDialog";
import get_results from "../Redux/reducers/get_results"
import get_tests from "../Redux/reducers/get_tests"
import ContentDialog from "./ContentDialog";
import { Alarm, CalendarTodayOutlined, ChatOutlined, Crop, DownloadOutlined, FilePresentOutlined,FileUploadOutlined,Filter9PlusOutlined,HomeOutlined,LinkedIn, Logout, MenuBookRounded, PeopleAltSharp, PeopleOutlined, QuizOutlined, SwitchLeft, SwitchRight, VerifiedUserRounded, Web } from "@mui/icons-material";
import ProfileDialog from "./ProfileDialog";
import { add_activities, add_activity } from "../Redux/settingSlice";
import { add_assessment } from "../Redux/templatesSlice";
import { add_job, add_jobs } from "../Redux/jobSlice";
import get_jobs from "../Redux/reducers/get_jobs";
import ResultDetailDialog from "./ResultDetailDialog";
import ResultAssDetailDialog from "./ResultAssDetailDialog";

const drawerWidth = 260;

const openedMixin = (theme) => ({
width: drawerWidth,
justifyContent:{xs:"flex-start",md:"space-between"},
alignItems:"center",
transition: theme.transitions.create('width', {
  easing: theme.transitions.easing.sharp,
  duration: theme.transitions.duration.enteringScreen,
}),
overflowX: 'hidden',
overflowY: 'scroll',
'&::-webkit-scrollbar': {
  width: 5,
  backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
  backgroundColor: '#ffffff',
  borderRadius: 10
}
});

const closedMixin = (theme) => ({
transition: theme.transitions.create('width', {
  easing: theme.transitions.easing.sharp,
  duration: theme.transitions.duration.leavingScreen,
}),
overflowX: 'hidden',
width: `calc(${theme.spacing(7)} + 1px)`,
[theme.breakpoints.up('sm')]: {
  width: `calc(${theme.spacing(8)} + 1px)`,
},
});

const DrawerHeader = styled('div')(({ theme }) => ({
display: 'flex',
alignItems: 'flex-start',
justifyContent: 'space-around',
padding: theme.spacing(0, 1),
background:theme.palette.mode === 'dark' ?  '#100101' : '#192f6a',
borderWidth:2,
borderRadius:5,
width:"90%",
margin:10,
// necessary for content to be below app bar
...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
shouldForwardProp: (prop) => (prop !== 'open' || prop !== 'openRight'),
})(({ theme, open,openRight }) => ({
zIndex: theme.zIndex.drawer + 1,
width: `calc(100% - ${drawerWidth}px)`,
transition: theme.transitions.create(['width', 'margin'], {
  easing: theme.transitions.easing.sharp,
  duration: theme.transitions.duration.leavingScreen,
}),
...(open && {
  marginLeft: drawerWidth,
  background:"#100101",
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),

}),
...(!open && {
  width: `calc(100% - 10px)`,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  })
})

}));

const AppContainer = styled(Container, {
  })(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
'&::-webkit-scrollbar': {
  width: 7,
  backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
  backgroundColor: '#ffffff',
  borderRadius: 5
},
overflowY: 'auto',
overflowX: 'hidden',
minHeight:550,
maxHeight:600,
marginTop:80,
width: open ? `calc(100%)` : `calc(100% + ${drawerWidth})`
  })
);

const ActiveBox = styled(Container, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
maxHeight:130,
minHeight:165,
width:drawerWidth,
marginLeft:-20,
padding:1,
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
  paddingBottom:10
})
);

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#000000'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
  background:"#100101",
  maxHeight:500,
  minHeight:450
})
);

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
({ theme, open }) => ({
  width: drawerWidth+10,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    // '& .MuiDrawer-paper': closedMixin(theme),
  })
}),
);

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
  height:30,
  background:"transparent"
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.5rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  // background:
  //   theme.palette.mode === 'dark'
  //     ? 'black'
  //     : 'white',
  height:30,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  // padding: theme.spacing(2),
  // background:
  //   theme.palette.mode === 'dark'
  //     ? 'black'
  //     : 'white',
}));

const JobText = ({navigate,dispatch,job,text,limit})=>{
  const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
  return <Button onClick={(e)=>{
    e?.preventDefault()
    // localStorage.setItem("iTest_job",JSON.stringify({
    //     id:tst?.id,
    //     name:tst?.name,
    //     description:tst?.description,
    //     time:tst?.time,
    //     start_moment:tst?.start_moment,
    //     start_date:tst?.start_date,
    //     questions:tst?.questions,
    //     language:tst?.language,
    //     describe:tst?.describe,
    //     specialty:tst?.specialty,
    //     field:tst?.field,
    //     isTest:tst?.isTest,
    //     level:tst?.level
    //   }))
      dispatch(add_job(job))
      navigate("/jobInfo")
  }}  style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,marginLeft:5,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
}

const MaxText = ({navigate,dispatch,tst,text,limit})=>{
  const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
  return <Button onClick={(e)=>{
    e?.preventDefault()
    localStorage.setItem("iTest_test",JSON.stringify({
        id:tst?.id,
        name:tst?.name,
        description:tst?.description,
        time:tst?.time,
        start_moment:tst?.start_moment,
        start_date:tst?.start_date,
        questions:tst?.questions,
        language:tst?.language,
        describe:tst?.describe,
        specialty:tst?.specialty,
        isRealTime:tst?.isRealTime,
        field:tst?.field,
        isTest:tst?.isTest,
        owner:tst?.owner,
        testQuestions:tst?.testQuestions || [],
        level:tst?.level
      }))
    if(tst?.isTest){
      navigate("/testInfo")
      dispatch(add_test(tst))
    }else{
      navigate("/assessmentInfo")
      dispatch(add_assessment(tst))
    }
  }}  style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,marginLeft:5,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
}

const ResultText = ({navigate,dispatch,tst,text,limit})=>{
  const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
  return <Button style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,marginLeft:5,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
}
  
const DescriptionText = ({text,limit})=>{
  const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
  return <Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,marginLeft:5}}> {displayText} </Typography>
}


const Layout = ({children}) => {

const theme = useTheme();
const [open, setOpen] = React.useState(true);
const [visible, setVisible] = React.useState(false);
const [message, setMessage] = React.useState("");
const [openRight, setOpenRight] = React.useState(true);
const [selected, setSelected] = React.useState("Assessment");
const [refreshing, setRefreshing] = React.useState(false);
const [dataRefresh, setDataRefresh] = React.useState(false);
const [showModal, setShowModal] = React.useState(false);
const [showProfile, setShowProfile] = React.useState(false);
const [showResultModal, setShowResultModal] = React.useState(false);
const [showAssResultModal, setShowAssResultModal] = React.useState(false);
const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
const [mobileAnchorEl, setMobileAnchorEl] = React.useState(null);
const navigate = useNavigate()
const [anchorEl, setAnchorEl] = React.useState(null);
const [expanded, setExpanded] = React.useState(false);
const user = useSelector(state => state.auth.user);
const activities = useSelector(state => state.setting.activities);
const [jobs, setJobs] = React.useState([]);
const [results, setResults] = React.useState([]);
const [result, setResult] = React.useState('');
const [testArray, setTestArray] = React.useState([]);
const [score, setScore] = React.useState(0);
const dispatch = useDispatch()

const isMenuOpen = Boolean(anchorEl);
const isApiMenuOpen = Boolean(mobileAnchorEl);
const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

const menuId = 'primary-search-account-menu';
const mobileMenuId = 'primary-search-account-menu-mobile';


React.useEffect(()=>{
  get_results(user?.email,setResults,user?.accessToken)
  get_tests(user?.email,setTestArray,add_tests,dispatch,user?.accessToken)
  get_jobs(user?.email,setJobs,add_jobs,dispatch,user?.accessToken)
  // getActivities()
},[])

// async function getActivities (){
//   const getData = await localStorage.getItem("activities")

//   if(getData){
//     dispatch(add_activities(JSON.parse(getData)))
//   }
// }

const handleDrawerOpen = () => {
  setOpen(true);
};

const handleDrawerClose = () => {
  setOpen(false);
};

const handleRefresh = async () => {
  try{

    setRefreshing(true)
    await get_tests(user?.email,setTestArray,add_tests,dispatch,user?.accessToken)
    await get_results(user?.email,setResults,user?.accessToken)
    await get_jobs(user?.email,setJobs,add_jobs,dispatch,user?.accessToken)
    setRefreshing(false)
    
  }catch(err){
    console.log(err)
  }  
};

function refreshPage(e) {
  setDataRefresh(true)
  e?.preventDefault()
  window?.location?.reload(true);
}

const handleProfileMenuOpen = (event) => {
  setAnchorEl(event?.currentTarget);
};

const handleMobileMenuClose = () => {
  setMobileMoreAnchorEl(null);
};

const handleMenuClose = () => {
  setAnchorEl(null);
  handleMobileMenuClose();
};

const handleShow = () => {
  if (openRight) {
    setOpenRight(false)
  } else {
    setOpenRight(true)
  }
};

const handleClose = () => {
  setMobileAnchorEl(null);
};
const handleOpen = (event) => {
  setMobileAnchorEl(event?.currentTarget);
};

const handleMobileMenuOpen = (event) => {
  setMobileMoreAnchorEl(event?.currentTarget);
};

const handleChange = () => (event, newExpanded) => {
  setExpanded1(newExpanded ? true : false);
};


const handleLogout = async ()=>{
  setAnchorEl(null);
  handleMobileMenuClose();
  localStorage.removeItem("iTestUser")
  localStorage.removeItem("iTest_test")
  localStorage.removeItem("activities")
  localStorage.clear()
  dispatch(logout())
  navigate('/login')

}

const handleTheme = ()=>{
  setAnchorEl(null);
  handleMobileMenuClose();
  // dispatch(toggleTheme())  
  // localStorage.setItem("theme",JSON.stringify({
  //       mode: (get_theme === "light" ? "dark" : "light")
  //   }))
}

const handleChangeExpanded = () => (event, newExpanded) => {
  setExpanded(newExpanded ? true : false);
};


const renderMenu = (
  <Menu
    anchorEl={anchorEl}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    id={menuId}
    keepMounted
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    open={isMenuOpen}
    onClose={handleMenuClose}
  >
    <MenuItem sx={{width:250,height:40}} onClick={()=>{
          setVisible(true)
          setMessage("this feature is not available on this current version")
        }} >
      <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"

        >
          <DownloadOutlined fontSize="small"/>
        </IconButton>
        <p style={{marginLeft:10,fontSize:12}}>Check for update</p>
    </MenuItem>
    <MenuItem sx={{width:250,height:40}} onClick={()=>{
          setVisible(true)
          setMessage("this feature is not available on this current version")
        }} >
      <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"

        >
          {
            theme.palette.mode == "dark" ? <SwitchRight fontSize="small"/> : <SwitchLeft fontSize="small"/>
          }
        </IconButton>
        <p style={{marginLeft:10,fontSize:12}}>Change theme</p>
    </MenuItem>
    <MenuItem sx={{width:250,height:40}} onClick={handleLogout}>
      <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <Logout fontSize="small"/>
        </IconButton>
        <p style={{marginLeft:10,fontSize:12}}>Log out</p>
      </MenuItem>
  </Menu>
);

const renderMobileMenu = (
  <Menu
    anchorEl={mobileMoreAnchorEl}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    id={mobileMenuId}
    keepMounted
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    open={isMobileMenuOpen}
    onClose={handleMobileMenuClose}
  >
    <MenuItem sx={{width:250,height:40}} onClick={()=>{

    }}>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="primary-search-account-menu"
        aria-haspopup="true"
        color="inherit"
      >
        <CodeIcon fontSize="small"/>
      </IconButton>
      <p style={{marginLeft:10,fontSize:12}}>API Doc</p>
    </MenuItem>
    <MenuItem sx={{width:250,height:40}} onClick={handleLogout}>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="primary-search-account-menu"
        aria-haspopup="true"
        color="inherit"
      >
        <Logout fontSize="small"/>
      </IconButton>
      <p style={{marginLeft:10,fontSize:12}}>Log out</p>
    </MenuItem>
  </Menu>
);

const renderApiMenu = (
  <Menu
    anchorEl={mobileAnchorEl}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    id={menuId}
    keepMounted
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    open={isApiMenuOpen}
    onClose={handleClose}
  >
    <MenuItem sx={{width:250,height:40}}>
      <IconButton
        size="large"
        color="inherit"
      >
        <CodeIcon fontSize="small"/>
      </IconButton>
      <p style={{marginLeft:10,fontSize:12}}>API Doc</p>
    </MenuItem>
    <MenuItem onClick={()=>{

    }} sx={{width:250,height:40}}>
      <IconButton
        size="large"
        aria-controls="primary-search-account-menu"
        aria-haspopup="true"
        color="inherit"
      >
        <ChatOutlined fontSize="small"/>
      </IconButton>
      <p style={{marginLeft:10,fontSize:12}}>Forum</p>
    </MenuItem>
  </Menu>
);

return(

  <Box sx={{ display: 'flex' }}>
    <CssBaseline />
    <AppBar  position="fixed" open={open}>
      <Toolbar sx={{background:"#100101"}}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginRight: 2,
            ...(open && { display: 'none' }),
            background:"white",
            borderRadius:2
          }}
        >
          <ChevronRightIcon fontSize="small" sx={{color:'black'}} />
        </IconButton>
        <IconButton
          color="inherit"
          onClick={(e)=>{refreshPage(e)}}
          edge="start"
          sx={{
            marginRight: 1,
            ...(open && { display: 'none' }),
            height:38,
            borderRadius:2,
            justifyContent:"center",
            display:{xs:"none",md:"block"}
          }}

          
        >
        {
          dataRefresh ? <CircularProgress size={20} sx={{color:"gold"}} /> : <RefreshIcon fontSize="small" sx={{color:'gold'}} />
        }  
        </IconButton>
        <IconButton onClick={(e)=>{
            e?.preventDefault()
            navigate("/dashboard")
        }} style={{borderRadius:2}}>
          <img width={25} height={25} style={{marginRight:4}} src={require('../assets/test.png')}/>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' ,fontSize:25,marginLeft:1,fontFamily:"zolla"} }}
          >
            iTest
          </Typography>
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: { xs: 'none', md: 'flex' },width:"40%",justifyContent:"space-evenly",alignItems:"center" }}>
          <IconButton edge="end"
                aria-controls={menuId}
                aria-haspopup="true"
                // onClick={handleOpen}
                onClick={()=>{
                  setVisible(true)
                  setMessage("This feature is not available in this current version")
                }}
                size="small" 
                sx={{borderRadius:2,background:"#060202",p:1}}
                color="inherit">
                <CodeIcon fontSize="small"  sx={{color:"gray",mr:1}}/> 
                <Typography sx={{color:"gold",fontWeight:500,fontSize:12}}>
                  API
                </Typography>
              </IconButton>
            <IconButton onClick={(e)=>{
                e?.preventDefault()
                setVisible(true)
                setMessage("This feature is not available in this current version")
                // setShowModal(true)
              }} sx={{borderRadius:2,background:"#060202",p:1}} size="small" color="inherit">
                <StarIcon fontSize="small"  sx={{color:"gray",mr:1}}/> 
                <Typography sx={{color:"gold",fontWeight:500,fontSize:{xs:10,md:12}}}>
                  Go Premium
                </Typography>
              </IconButton >
            <IconButton onClick={(e)=>{
                e?.preventDefault()
                navigate("/jobs")
              }} sx={{borderRadius:2,background:"#060202",p:1}} size="small" >
                <PeopleAltSharp fontSize="small" sx={{color:"gray",mr:1}} color="gold"/> 
                <Typography sx={{color:"gold",fontWeight:500,fontSize:{xs:10,md:12}}}>
                Offers
              </Typography>
              </IconButton >
            <IconButton onClick={(e)=>{
              e?.preventDefault()
              navigate("/createTest")
            }} size="small" aria-label="show 4 new mails" color="inherit">
              <AddIcon />
            </IconButton>
            <IconButton onClick={(e)=>{
              e?.preventDefault()
              navigate("/createTemplate")
            }}
              size="large"
              color="inherit"
            >
              <Filter9PlusOutlined fontSize="small"/>
          </IconButton>
          <IconButton
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            <Badge badgeContent="update" color="error">
              <SettingsOutlinedIcon fontSize="small"/>
            </Badge>
          </IconButton>
        </Box>
        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
          <IconButton onClick={(e)=>{
              e?.preventDefault()
              setVisible(true)
              setMessage("This feature is not available in this current version")
              // setShowModal(true)
            }} sx={{borderRadius:2,background:"#191919",width:150}} size="small" color="inherit">
              <StarIcon sx={{fontSize:18,mr:1,color:"gold",}} color="gray"/> 
              <Typography sx={{fontWeight:500,fontSize:12}}>
                Premium
              </Typography>
            </IconButton>
          <IconButton onClick={(e)=>{
              e?.preventDefault()
              navigate("/createTest")
            }}
              size="large"
              aria-label="show more"
              aria-haspopup="true"
              color="inherit"
            >
              <AddIcon fontSize="small"/>
          </IconButton>
          <IconButton
            size="large"
            aria-label="show more"
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            onClick={handleMobileMenuOpen}
            color="inherit"
          >
            <MoreIcon fontSize="small"/>
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
    {renderMobileMenu}
    {renderMenu}
    {renderApiMenu}
      <Snackbar 
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }} 
          message={message} 
          onClose={()=>{setVisible(false)}} 
          open={visible} 
          autoHideDuration={2000}
      />
        <Drawer  variant="permanent" open={open} >
          <DrawerHeader sx={{ opacity: open ? 1 : 0,display: open ? "block" :"none"}}>
              <Box pt={1} style={{justifyContent:"center",alignItems:"center",width:"100%"}}>
                  <IconButton onClick={handleDrawerClose} sx={{background:'white',borderRadius:2,marginLeft:20}}>
                    <ChevronLeftIcon sx={{color:'black'}}/>
                  </IconButton>              
              </Box>
              <Box sx={{display: open ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20,marginTop:2}}>
                <IconButton size="large" color="inherit" >
                    <VerifiedUserRounded fontSize="small" style={{color:"gold"}}/>
                </IconButton>
                <Box sx={{display: open ? "flex" :"none",flexDirection:"row",justifyContent:"space-evenly",alignItems:"center"}}>
                  <Typography style={{fontWeight:500,fontSize:14,color:'gray',fontFamily:"dinofans"}}>
                      Profile
                  </Typography> 
                  {/* {
                    !user?.isUserVerified && (
                      <Typography sx={{ml:1,fontSize:11,color:'red'}}>
                        !!
                      </Typography>
                    )
                  } */}
                </Box>
                        
              </Box>
              <Box  sx={{justifyContent:"center",alignItems:"center",width:"100%"}} >
                 <Box width="100%" display="flex" flexDirection="row" justifyContent="center" alignItems="center">
                  <IconButton onClick={(e)=>{
                      e?.preventDefault()
                        navigate("/profile")
                      }} size="large" color="inherit" >
                          {
                            user?.profile !== "https://" ?  
                              <img resizemode="cover" src={user?.profile} width={75} height={75} style={{borderRadius:40}}/>
                            :
                              <img resizemode="cover" src={require("../assets/avatar.jpg")} width={75} height={75} style={{borderRadius:40}}/>
                          }
                    </IconButton> 
                 </Box> 
                <Box mb={1}  sx={{justifyContent:"space-between",alignItems:"center",display:open ? "flex" : "none",flexDirection:"row",width:"100%"}}>
                  <Box ml={1}>
                    <Typography style={{fontWeight:500,fontSize:15,color:'white',fontFamily:"dinofans"}}>
                      {user?.last_name} {user?.first_name}
                    </Typography> 
                    <Typography style={{fontWeight:500,fontSize:11,color:'gray',fontWeight:"bold"}}>
                      {user?.email}
                    </Typography>  
                  </Box> 
                  <IconButton onClick={(e)=>{
                      e?.preventDefault()
                      navigate("/profile")
                    }} sx={{ml:1}}>
                      <ChevronRightIcon sx={{color:'#ff0'}}/>
                  </IconButton>                      
                </Box>
                <Divider/>
                <ActiveBox >
                  <Box sx={{display: open ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20,marginTop:2}}>
                    <IconButton size="large" color="inherit" >
                        <HomeIcon fontSize="small" style={{color:"gold"}}/>
                    </IconButton>
                    <Typography style={{fontWeight:500,fontSize:14,color:'gray',marginTop:4,fontFamily:"dinofans"}}>
                        Recent activities
                    </Typography>                         
                  </Box>
                  {
                  activities?.length == 0 && (
                    <Box justifyContent="center" alignItems="center" sx={{padding:1}}>
                      <Box justifyContent="center" alignItems="center" ml={6}>
                        <img style={{ marginLeft: 20 }} width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
                      </Box>
                      <Typography sx={{fontSize:12,color:'white',marginLeft:7,fontFamily:"nsai"}}>
                          No activities
                        </Typography> 
                    </Box>
                  )
                } 
                {
                  activities?.map((item,index)=>{
                    return(
                      <Box key={index} style={{ cursor: 'pointer',}}  sx={{padding:1,background:"#000000",borderRadius:2,margin:1,'&:hover': {backgroundColor: "#250606",}}}>
                        <Button onClick={(e)=>{
                          e?.preventDefault()
                          dispatch(add_activity(item))
                          navigate("/testDetail")
                        }} style={{fontWeight:400,fontSize:11,color:'white',marginLeft:5,fontFamily:"dinofans",color:"gold",borderWidth:0}}> #{index+1}  {item?.title} </Button> 
                        <Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center">
                          <Box>
                            <QuizOutlined fontSize='small'/>
                            <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                              {item?.level}
                            </Typography>
                          </Box>
                          <Box>
                            <CalendarTodayOutlined fontSize='small'/>
                            <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                              {item?.start_date}
                            </Typography>
                          </Box>
                          <Box>
                            <Alarm fontSize='small'/>
                            <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                              {item?.start_moment}
                            </Typography>
                          </Box>
                        </Box>
                    </Box>
                    )
                  })
                } 
              </ActiveBox>
            </Box>
          </DrawerHeader>
          <DrawerHeader sx={{padding:2,display: open ? "block" :"none"}}>
            <Box sx={{display: open ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20}}>
              <IconButton  size="large" color="inherit" >
                  <AlarmIcon fontSize="small" style={{color:"gold"}}/>
              </IconButton>
              <Typography style={{fontWeight:500,fontSize:14,color:'gray',marginTop:4,fontFamily:"dinofans"}}>
                  Contact us
              </Typography>                         
            </Box>
            <Box ml={1} sx={{display: open ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20,marginTop:1}}>
              <IconButton  size="large" color="inherit" >
                  <LinkedIn fontSize="small" style={{color:"gray"}}/>
              </IconButton>
              <Typography style={{fontWeight:500,fontSize:12,color:'white',fontWeight:"bold"}}>
                Rodrigue-butoyi
              </Typography>                         
            </Box>
            <Box ml={1} sx={{display: open ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20,marginTop:1}}>
              <IconButton  size="large" color="inherit" >
                  <Web fontSize="small" style={{color:"gray"}}/>
              </IconButton>
              <Typography style={{fontWeight:500,fontSize:12,color:'white',fontWeight:"bold"}}>
                sagintel.github.io
              </Typography>                         
            </Box>
          </DrawerHeader>
        </Drawer>
        <AppContainer sx={{xs:{height:"100%"}}}>
          <main>
            {children}
          </main>
        </AppContainer>
        <Box sx={{width:{xs:0,md:220},borderRadius:3,margin:1,display:{xs:"none",md:"block",position:"relative"}}}>
                <Box p={1} style={{justifyContent:"center",alignItems:"center",width:"100%"}}>
                    <IconButton onClick={handleShow} sx={{background:'white',borderRadius:2,marginLeft:22}}>
                        <MenuIcon fontSize="small" sx={{color:'black'}}/>
                    </IconButton>              
                </Box>
                <IconButton
                    color="inherit"
                    onClick={handleRefresh}
                    edge="start"
                    sx={{
                      ...(openRight && { display: 'none' }),
                      height:38,
                      borderRadius:2,
                      justifyContent:"center",
                      margin:1,
                      mt:2,
                      display:{xs:"none",md:openRight ? "block" : "none",background:"#ffffff"}
                    }}
                  >
                    {
                      refreshing ?  <CircularProgress size={20} sx={{color:"#000000"}} /> : <RefreshIcon fontSize="small" sx={{color:'#000000'}} />
                    }
                  </IconButton>
                <ContainerBox sx={{display:{xs:"none",md:openRight ? "block" : "none",marginRight:2,borderRadius:3}}}>
                  <Box>
                      <Box sx={{display: openRight ? "flex" :"none",flexDirection:"row",justifyContent:"space-between",alignItems:"center",height:20,marginTop:2,padding:1}}>
                          <IconButton onClick={(e)=>{
                            e?.preventDefault()
                            setSelected("Assessment")
                          }} sx={{borderRadius:2,background:(selected ===  "Assessment" ? "#fff"  : "transparent"),height:30}}>
                              <Typography style={{fontWeight:500,fontSize:11,color:(selected ===  "Assessment" ? "#000"  : "#fff"),marginTop:2,fontFamily:"dinofans"}}>
                                  Assessm...
                              </Typography>
                          </IconButton>
                          <IconButton onClick={(e)=>{
                            e?.preventDefault()
                            setSelected("Jobs")
                          }} sx={{borderRadius:2,background:(selected ===  "Jobs" ? "#fff"  : "transparent"),height:30}}>
                              <Typography style={{fontWeight:500,fontSize:11,color:(selected ===  "Jobs" ? "#000"  : "#fff"),marginTop:2,fontFamily:"dinofans"}}>
                                  offers
                              </Typography> 
                          </IconButton>
                          <IconButton onClick={(e)=>{
                            e?.preventDefault()
                            setSelected("Results")
                          }} sx={{borderRadius:2,background:(selected ===  "Results" ? "#fff"  : "transparent"),height:30}}>
                            <Typography style={{fontWeight:500,fontSize:11,color:(selected ===  "Results" ? "#000"  : "#fff"),marginTop:2,fontFamily:"dinofans"}}>
                                Results
                            </Typography>
                          </IconButton>                        
                      </Box>
                    </Box>
                      {selected === "Assessment" ? 
                        <>
                        <Box sx={{display: openRight ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20,marginTop:2,marginLeft:1}}>
                          <IconButton size="large" color="inherit" >
                              <FilePresentOutlined fontSize="small" style={{color:"gold"}}/>
                          </IconButton>
                          <Typography style={{fontWeight:500,fontSize:12,color:'gray',marginTop:4,fontFamily:"dinofans"}}>
                              Recent Assessments
                          </Typography>                         
                        </Box>  
                          {
                            testArray?.length == 0 && (
                              <Box textAlign="center" sx={{padding:1}}>
                                <Box justifyContent="center" alignItems="center" >
                                  <img width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
                                </Box>
                                <Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:10}}>
                                  Assessments could not be found
                                </Typography>
                                  <Box textAlign="center"width="100%" mt={1}>
                                    <Button onClick={(e)=>{
                                      e?.preventDefault()
                                      navigate("/createTest")
                                    }} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
                                      Create now
                                  </Button>
                                  </Box>  
                              </Box>
                            )
                          } 
                          {
                            testArray?.map((item,index)=>{
                              return(
                                <Box key={index} sx={{padding:1,background:"black",borderRadius:2,margin:1,width:"95%",justifyContent:"center",alignContent:"center"}}>
                                  <MaxText navigate={navigate} dispatch={dispatch} tst={item} text={`# ${index+1}  ${item?.name}`} limit={30}/>
                                  <Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center" >
                                    <Box>
                                      <QuizOutlined fontSize='small'/>
                                      <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                                        {item?.level}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <CalendarTodayOutlined fontSize='small'/>
                                      <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                                        {item?.start_date}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <AlarmIcon fontSize='small'/>
                                      <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                                        {item?.start_moment}
                                      </Typography>
                                    </Box>
                                  </Box> 
                                  <DescriptionText text={item?.description} limit={45}/> 
                              </Box>
                              )
                            })
                          } 
                        </>
                        : selected === "Jobs"  ?
                        <>
                          <Box sx={{display: openRight ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20,marginTop:2,marginLeft:1}}>
                            <IconButton size="large" color="inherit" >
                                <FilePresentOutlined fontSize="small" style={{color:"gold"}}/>
                            </IconButton>
                            <Typography style={{fontWeight:500,fontSize:12,color:'gray',marginTop:4,fontFamily:"dinofans"}}>
                                Recent Jobs
                            </Typography>                         
                          </Box>  
                            {
                              jobs?.length == 0 && (
                                <Box textAlign="center" sx={{padding:1}}>
                                  <Box justifyContent="center" alignItems="center" >
                                    <img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
                                  </Box>
                                  <Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:10}}>
                                    Jobs could not be found
                                  </Typography>
                                    <Box textAlign="center" width="100%" mt={1}>
                                      <Button onClick={(e)=>{
                                        e?.preventDefault()
                                        navigate("/addJob")
                                      }} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
                                        Create now
                                    </Button>
                                    </Box>  
                                </Box>
                              )
                            }
                            {jobs?.map((item,index)=>{
                              return(
                                <Box key={index} sx={{padding:1,background:"black",borderRadius:2,margin:1,width:"95%",justifyContent:"center",alignContent:"center"}}>
                                  <JobText navigate={navigate} dispatch={dispatch} job={item} text={`# ${index+1}  ${item?.title}`} limit={30}/>
                                  <Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center" >
                                    <Box>
                                      <QuizOutlined fontSize='small'/>
                                      <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                                        {item?.category}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <CalendarTodayOutlined fontSize='small'/>
                                      <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                                        {item?.type}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <AlarmIcon fontSize='small'/>
                                      <Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
                                        {item?.deadline}
                                      </Typography>
                                    </Box>
                                  </Box> 
                                  <DescriptionText text={item?.description} limit={45}/> 
                              </Box>
                              )
                            })
                          } 
                        </>
                        :
                        <Box>
                          <Box sx={{display: openRight ? "flex" :"none",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",height:20,marginTop:2,marginLeft:1}}>
                            <IconButton size="large" color="inherit" >
                                <MenuBookRounded fontSize="small" style={{color:"gold"}}/>
                            </IconButton>
                            <Typography style={{fontWeight:500,fontSize:12,color:'gray',marginTop:4,fontFamily:"dinofans"}}>
                                Assessment results
                            </Typography>                         
                          </Box>
                          {
                            results?.length == 0 && (
                              <Box textAlign="center" sx={{padding:1}}>
                                  <Box justifyContent="center" alignItems="center" >
                                    <img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
                                  </Box>
                                  <Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:10}}>
                                    Results could not be found
                                  </Typography> 
                              </Box>
                            )
                          } 
                          {
                            results?.map((item,index)=>{
                              return(
                                <Box key={index} sx={{padding:1,background:"black",borderRadius:2,margin:1,width:"95%",justifyContent:"center",alignContent:"center"}}>
                                    <ResultText text={`# ${index+1}  ${item?.title}`} limit={30}/>
                                    <Box m={1} display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center">
                                      <Typography width={50} p={1} borderRadius={2} sx={{fontSize:12,color:(item?.conclusion !== "pending" ? "white" : "black"),background:(item?.conclusion === "pending" ? "gold" : item?.conclusion === "fail" ? "red" : "green")}}>
                                          {item?.score} %
                                      </Typography>
                                      <Box p={1} display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center">
                                        <CalendarTodayOutlined fontSize='small'/>
                                        <Typography sx={{fontSize:10,fontWeight:400,color:"gray",paddingLeft:1}}>
                                          {item?.test_date}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    {
                                      ((item?.conclusion === "fail" || item?.conclusion === "accept") && !item?.isDisqualified) && (
                                        <Button onClick={()=>{
                                            setResult(item?.data)
                                            setScore(item?.score)
                                            // console.log(item?.data)
                                            if(item?.isTest){
                                              setShowResultModal(true)
                                            }else{
                                              setShowAssResultModal(true)
                                            }
                                          }} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9,marginLeft:2}} variant="contained">
                                            Result
                                        </Button>                                    
                                      )
                                    }
                                    {
                                      item?.isDisqualified && (
                                        <Typography  p={1} ml={1} borderRadius={2} sx={{fontSize:12,color:"white",background:"red"}}>
                                          You have been Disqualified
                                        </Typography>
                                      )
                                    }		
                                    {
                                      !item?.isDisqualified && (
                                        <DescriptionText text={item?.description} limit={120}/> 
                                      )
                                    }
                                </Box>
                              )
                            })
                          }
                      </Box>
                      }
                  </ContainerBox>                  
              </Box>
        <PremiumDialog visible={showModal} setVisible={setShowModal}/>
        <ProfileDialog visible={showProfile} setVisible={setShowProfile}/>
        <ResultAssDetailDialog score={score} visible={showAssResultModal} setVisible={setShowAssResultModal} content={result}/>
        <ResultDetailDialog visible={showResultModal} setVisible={setShowResultModal} content={result}/>
  </Box>

  )
};

export default Layout